const setAdvicesUrl = LINK_ADVICESPAGE => ({ LINK_ADVICESPAGE });
const setSearchUrl = LINK_SEARCHPAGE => ({ LINK_SEARCHPAGE });
const setJobOffersUrl = LINK_JOB_OFFERS => ({ LINK_JOB_OFFERS });
const setAddJobAlertUrl = LINK_ADD_JOB_ALERT => ({ LINK_ADD_JOB_ALERT });
const setJobAlertsUrl = LINK_JOB_ALERTS => ({ LINK_JOB_ALERTS });
const setLoginUrl = LINK_LOGIN => ({ LINK_LOGIN });
const setAccountUrl = LINK_ACCOUNT => ({ LINK_ACCOUNT });
const setHomepageUrl = LINK_HOMEPAGE => ({ LINK_HOMEPAGE });
const setSettingsUrl = LINK_SETTINGS => ({ LINK_SETTINGS });
const setSearchFilterUrl = LINK_SEARCH_FILTER => ({ LINK_SEARCH_FILTER });
const setProfileUrl = LINK_PROFILE => ({ LINK_PROFILE });
const setSavedOffersUrl = LINK_SAVED_OFFERS => ({ LINK_SAVED_OFFERS });
const setMyApplicationsUrl = LINK_MY_APPLICATIONS => ({ LINK_MY_APPLICATIONS });

module.exports = {
  ...setAdvicesUrl(process.env.LINK_ADVICESPAGE),
  ...setSearchUrl(process.env.LINK_SEARCHPAGE),
  ...setJobOffersUrl(process.env.LINK_JOB_OFFERS),
  ...setAddJobAlertUrl(process.env.LINK_ADD_JOB_ALERT),
  ...setJobAlertsUrl(process.env.LINK_JOB_ALERTS),
  ...setLoginUrl(process.env.LINK_LOGIN),
  ...setAccountUrl(process.env.LINK_ACCOUNT),
  ...setHomepageUrl(process.env.LINK_HOMEPAGE),
  ...setSettingsUrl(process.env.LINK_SETTINGS),
  ...setSearchFilterUrl(process.env.LINK_SEARCH_FILTER),
  ...setProfileUrl(process.env.LINK_PROFILE),
  ...setSavedOffersUrl(process.env.LINK_SAVED_OFFERS),
  ...setMyApplicationsUrl(process.env.LINK_MY_APPLICATIONS)
};
